import React from 'react'
import { BtSelect } from '@linqpal/components/src/ui'
import { observer } from 'mobx-react'
import { useEditorModel } from '../../useEditorModel'
import { useTranslation } from 'react-i18next'
import { MAIN_ID } from '@linqpal/models/src/dictionaries/onboarding'
import { Spacer } from '../../../../../ui/atoms'

function validate(value) {
  return !!value && (value as []).length > 0
}

const initialValue: string[] | null = []

function Category(props) {
  const { doc, group, item, onValueUpdate, review } = props
  const model = useEditorModel(
    doc,
    group,
    item,
    onValueUpdate,
    initialValue,
    validate,
  )
  const { t } = useTranslation('application')
  const { t: ot } = useTranslation('onboarding')

  // Changed options to value and label because we also need to save this answer in company record
  const options = [
    { value: MAIN_ID.SUB_CONTRACTOR, label: ot('subContractor') },
    { value: MAIN_ID.GENERAL_CONTRACTOR, label: ot('generalContractor') },
    {
      value: MAIN_ID.DEALER_RETAILER_SUPPLIER,
      label: ot('dealerRetailerSupplier'),
    },
    {
      value: MAIN_ID.MANUFACTURER_DISTRIBUTOR,
      label: ot('manufacturerDistributor'),
    },
    {
      value: MAIN_ID.ARCHITECT_INTERIOR_DESIGNER,
      label: ot('architectInteriorDesigner'),
    },
    { value: MAIN_ID.ENGINEER_CONSULTANT, label: ot('engineerConsultant') },
    {
      value: MAIN_ID.DEVELOPER_PROPERTY_OWNER,
      label: ot('developerPropertyOwner'),
    },
    { value: MAIN_ID.OTHER, label: ot('other') },
  ]

  return (
    <>
      <Spacer height={review ? 24 : 18} />
      <BtSelect
        model={model}
        label={t('Business.CategoryLabel')}
        placeholder={t('Business.CategoryPlaceholder')}
        options={options}
        keyName="value"
        labelName="label"
        onChange={(selected) => model.setValue('value', selected.value)}
        name="value"
        testID="BusinessCategoryInput"
      />
    </>
  )
}

export default {
  title: 'Business.Category',
  component: observer(Category),
  showFooterMessage: true,
}
